import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { useCallback } from "react";
import { AI_WORKSPACE_QUERY_KEYS } from "../constants";
import { AiWorkspaceService } from "../services/aiWorkspace.service";
import { IAIWorkspaceRequest, ICreateScriptVetRequestPayload } from "../types";
import { readApiError } from "./readApiError";

const QUERY_OPTIONS = {
  queryKey: [AI_WORKSPACE_QUERY_KEYS.REQUESTS],
  skipInvalidation: false,
};

export function useCreateScriptVetRequest(
  onSuccess?: (request: IAIWorkspaceRequest) => void
) {
  const createScriptVetRequest = useCallback(
    (payload: ICreateScriptVetRequestPayload) =>
      AiWorkspaceService.createScriptVetRequest(payload)
        .then((res) => {
          ToastService.success("Script check created");
          return res;
        })
        .catch(async (err) => {
          ToastService.error(
            await readApiError(err, "Failed to create script check")
          );
          throw err;
        }),
    []
  );

  const { mutate: create, isLoading: isCreating } = useMutation<
    ICreateScriptVetRequestPayload,
    BackednResponse<IAIWorkspaceRequest>
  >({
    mutationFn: createScriptVetRequest,
    options: QUERY_OPTIONS,
    onSuccess: (_client, data) => {
      if (data?.data) onSuccess?.(data.data);
    },
  });

  return { create, isCreating };
}
